import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "../modules/dashboard/Dashboard";
import Scan from "../modules/doc-input/Scan";
import Fax from "../modules/doc-input/Fax";
import Mail from "../modules/doc-input/Mail";
import NotFound from "../pages/NotFound";
import FileUpload from "../modules/doc-input/FileUpload";
import ProcessDocs from "../modules/doc-input/ProcessDocs";
import ManualReview from "../modules/doc-manual-review/ManualReview";
import Classify from "../modules/doc-classify/Classify";
import DocCenter from "../modules/doc-center/DocCenter";
import PipelineCenter from "../modules/pipeline/PipelineCenter";
import NER from "../modules/doc-ner/NER";
import PopupWindow from "../modules/doc-center/PopupWindow";
import ProtectedRoute from "../modules/security/ProtectedRoute";
import PipelineList from "../modules/pipeline/PipelineList";
import DynamicPipelineUI from "../modules/pipeline/DynamicPipelineUI";
import PipelineFlow from "../modules/pipeline/PipelineFlow";
import AdminCenter from "../modules/admin/entitlements/AdminCenter";
import ManageEntitlements from "../modules/admin/entitlements/ManageEntitlements";
import DocumentDetailPage from "../modules/doc-view/DocumentDetailPage";
import RootRedirect from "../modules/security/RootRedirect";
import Login from "../modules/security/Login";
import { useAuth } from "../modules/security/AuthContext"; // import here


const AppRoutes = () => {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/" element={<RootRedirect />} />
      <Route path="/login" element={
        user ? <Navigate to="/dashboard" replace /> : <Login />
        }/>
      <Route path="/dashboard" element={<ProtectedRoute object="ui-dashboard" action="view"><Dashboard /></ProtectedRoute>} />
      <Route path="/process-docs" element={<ProtectedRoute object="ui-healthxtract" action="view"><ProcessDocs /></ProtectedRoute>} />
      <Route path="/manual-review" element={<ProtectedRoute object="ui-manual-review" action="view"><ManualReview /></ProtectedRoute>} />
      <Route path="/doc-center" element={<ProtectedRoute object="ui-doc-center" action="view"><DocCenter /></ProtectedRoute>}/>
      <Route path="/doc-center/doc-view/:docId" element={<ProtectedRoute object="ui-doc-center" action="view"><DocumentDetailPage /></ProtectedRoute>}/>
      <Route path="/pipeline-center" element={<ProtectedRoute object="ui-pipeline-center" action="view"><PipelineCenter /></ProtectedRoute>} />
      <Route path="/pipeline-center/create" element={<ProtectedRoute object="ui-pipeline" action="create"><DynamicPipelineUI /></ProtectedRoute>} />
      <Route path="/pipeline-center/list" element={<ProtectedRoute object="ui-pipeline" action="list"><PipelineList /></ProtectedRoute>} />
      <Route path="/pipeline" element={<ProtectedRoute object="ui-pipeline" action="view"><PipelineFlow /></ProtectedRoute>} />
      <Route path="/popup" element={<ProtectedRoute object="ui-popup" action="view"><PopupWindow /></ProtectedRoute>} />
      <Route path="/upload" element={<ProtectedRoute object="ui-upload" action="view"><FileUpload /></ProtectedRoute>} />
      <Route path="/classify" element={<ProtectedRoute object="ui-classify" action="view"><Classify /></ProtectedRoute>} />
      <Route path="/ner" element={<ProtectedRoute object="ui-ner" action="view"><NER /></ProtectedRoute>} />
      <Route path="/scan" element={<ProtectedRoute object="ui-scan" action="view"><Scan /></ProtectedRoute>} />
      <Route path="/fax" element={<ProtectedRoute object="ui-fax" action="view"><Fax /></ProtectedRoute>} />
      <Route path="/mail" element={<ProtectedRoute object="ui-doc-center" action="view"><Mail /></ProtectedRoute>} />
      <Route path="/admin-center" element={<ProtectedRoute object="ui-doc-center" action="view"><AdminCenter /></ProtectedRoute>} />
      <Route path="/admin-center/entitlements" element={<ProtectedRoute object="ui-doc-center" action="view"><ManageEntitlements /></ProtectedRoute>} />
      <Route path="/unauthorized" element={<NotFound />}  />
    </Routes>
  );
};

export default AppRoutes;
